var map = {
	"./a-chinese-prespective-on-agchem-r&d.pdf": 9055,
	"./ag-top-chinese-crop-protection-companies-2018-report.pdf": 4438,
	"./brassinolide.pdf": 6716,
	"./chengdu-new-sun-pursues-green-agriculture-in-china.pdf": 3289,
	"./china-establishes-new-pesticide-regulations.pdf": 9554,
	"./crop-industry-and-crop-protection-business-in-canada.pdf": 9641,
	"./crop-protection-market-and-product-registration-in-canada_ shuyou-han_ 20190620-v2.pdf": 3249,
	"./crop-protection-market-in-canada.pdf": 9085,
	"./foison-glufosinate-ammonium.pdf": 1323,
	"./freedom-glyphosate.pdf": 8577,
	"./herbicides-q&a.pdf": 4019,
	"./how-does-chinese-pesticide-export-reshape-crop-protection-market-in-latin-america.pdf": 7621,
	"./interview-chinese-industry-confident-about-2017.pdf": 9183,
	"./interview-wynca-consolidation-in-chinese-industry-will-reduce-glyphosate-price-wars.pdf": 1106,
	"./lier-glufosinate-150-sn-english-label.pdf": 9165,
	"./nasa36.pdf": 7315,
	"./overview-on-crop-protection.pdf": 7515,
	"./patented-agrochemicals-invented-by-chinese-researchers.pdf": 37,
	"./plant-pretection-group-talk.pdf": 4826,
	"./plant-protection.pdf": 4692,
	"./the-global-agrochemical-market.pdf": 2151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2956;